import { Theme } from '@mui/material';
/**
 * @example styles for radio highlight component
 */
const ccfRadioHighlightStyles = (theme: Theme) => {
  const styles = {
    radioBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme?.palette?.background?.paper,
    },
    tooltipHeader: {
      color: theme?.palette?.background?.paper,
      font: `normal normal 600 10px/17px ${theme?.typography?.fontFamily} !important`,
      letterSpacing: '0px !important',
      opacity: '1 !important',
    },
  };
  return styles;
};

export default ccfRadioHighlightStyles;
